import React from 'react'
import { Alert, AlertIcon, Flex } from '@chakra-ui/react'

const ProgressNotesExplanation = () => (
  <Alert
    status="info"
    borderRadius="md"
    colorScheme="#F7F8FE"
    p="small"
  >
    <AlertIcon color='primary' marginRight="sm" />
    <Flex flexDirection='column'>
      This progress note is auto-generated using AI and should be reviewed and edited for accuracy before saving to client’s record.
    </Flex>
  </Alert>
)

export default ProgressNotesExplanation